<div v-bind:class="getClassName + ' matrix_selectOption_' + getCode">
  <div class="selectOptionNameContainer">
    <p class="selectOptionNameText">{{ $t(name) }}</p>
  </div>
  <div class="matrix_selectOptionInner">
    <Select2
      v-model="value"
      :options="options"
      :settings="settings"
      :id="getId"
    />
    <div style="display:none" class="matrix_selectOptionImageContainer" v-if="getImageUrl">
      <img :src="getImageUrl">
    </div>
  </div>
  <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>  
  <input v-if="showColorPickerForOption" id="margin_color_input" v-on:change="proccessMarginColor" type="color" :value="getMarginColor" style="width:100%; cursor: pointer;">
</div>
